import React from 'react';

import PedidosForm from './revendedora/PedidosForm';
import PedidosListagem from './revendedora/PedidosListagem';

import { useParams } from 'react-router';
import TitleModule from '../../../components/title/TitleModule';


const PedidosRev = props => {

    const params = useParams();
    const compra = params.modulo === 'pedidos-compra';
    const _title = compra ? "Pedidos Compra" : "Pedidos Venda";
    const title = [_title];
    if (params.acao && params.acao === "form") {
        if (params.id) {
            title.push("Editar");
        } else {
            title.push("Criar");
        }
    } else if (params.acao && params.acao === "view") {
        title.push("Visualizar");
    } else if (params.acao && params.acao === "process") {
        title.push("Processar");
    } else {
        title.push("Listagem");
    }

    return (
        <>
            <TitleModule titulo={title.join(' > ')} />
            {params.acao && params.acao === 'form' && <PedidosForm compra={compra} />}
            {!params.acao && <PedidosListagem compra={compra} />}
        </>
    );
};

export const getSituacao = pedido => {
    if (!pedido.cancelado && pedido.processado && pedido.entregue) return "Entregue";
    if (!pedido.cancelado && !pedido.entregue && !pedido.processado) return "Pendente";
    if (pedido.processado && !pedido.cancelado) return "Processado";
    if (pedido.cancelado) return "Cancelado";
}

export default PedidosRev;